module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff?92b716858bfb2c48f54b8e5d996830f7";